/**
 * gb-mega-header.js (v2) — Verhalten für gb-mega-header.liquid (golfballs.at)
 *
 * AUFRÄUMEN IN V2 — Entfernt wurde Code, der auf Markup gehört hat, das es
 * seit V5.8/V5.10 der Liquid-Datei nicht mehr gibt und der daher nie mehr
 * ausgelöst wurde:
 *   - Desktop-Inline-Suche (.gb-nav-search, .gb-nav-search__toggle,
 *     .gb-nav-search__input) — ersetzt durch das Such-Overlay, das über
 *     [data-gb-search-open] geöffnet und von gb-search-overlay.js bedient wird.
 *   - Mobile Such-Leisten (.gb-mobile-searchbar) — in V5.8 ersatzlos entfallen.
 *   - Mobile Accordion nach altem Schema (.gb-mobile__toggle /
 *     .gb-mobile__panel) — das Mobile-Menü arbeitet seit V5.10 mit
 *     Panel-Levels (.gb-mobile__cat-link, .gb-mobile__accordion-toggle) und
 *     wird vom Inline-Script in gb-mega-header.liquid gesteuert.
 * Diese Datei ist damit nur noch für zwei Dinge zuständig:
 *   1. Desktop-Mega-Menü (Hover + Tastatur-Fokus)
 *   2. Öffnen/Schließen der Mobile-Schublade
 */
(function () {
  document.querySelectorAll('gb-mega-header').forEach(function (header) {
    var navItems = header.querySelectorAll('[data-nav-item]');
    var CLOSE_DELAY = 200;

    function closeAll() {
      navItems.forEach(function (i) {
        i.classList.remove('is-open');
        var l = i.querySelector('.gb-nav-link');
        if (l) l.setAttribute('aria-expanded', 'false');
      });
    }

    function openItem(item) {
      navItems.forEach(function (i) {
        if (i !== item) {
          i.classList.remove('is-open');
          var l = i.querySelector('.gb-nav-link');
          if (l) l.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.add('is-open');
      var link = item.querySelector('.gb-nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    // --- Desktop Mega-Menü: Hover + Tastatur-Fokus ---
    // Der Kategorie-Name bleibt ein normaler Link (Klick navigiert zur
    // hinterlegten Seite); geöffnet wird ausschließlich über Hover/Fokus.
    navItems.forEach(function (item) {
      var link = item.querySelector('.gb-nav-link');
      if (!link) return;
      var closeTimer = null;

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          item.classList.remove('is-open');
          link.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      }
      function openNow() {
        clearTimeout(closeTimer);
        openItem(item);
      }

      item.addEventListener('mouseenter', openNow);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', openNow);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) scheduleClose();
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('gb-mega-header')) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    // --- Mobile Schublade öffnen/schließen ---
    // Die Navigation INNERHALB der Schublade (Panel-Levels, Akkordeons)
    // steuert das Inline-Script in gb-mega-header.liquid.
    var burger = header.querySelector('.gb-burger');
    var drawer = header.querySelector('.gb-mobile');
    var closeBtn = header.querySelector('.gb-mobile__close');

    function openDrawer() {
      if (!drawer) return;
      drawer.setAttribute('data-open', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('data-open', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (burger) burger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer();
      });
    }

    // Escape schließt auch die Schublade.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === 'true') {
        closeDrawer();
      }
    });
  });
})();